<script>
export default {
	name: 'LeafletLayerGroup',
	inheritAttrs: false,
	inject: [ 'leaflet', 'state' ],
	data() {
		return {
			layerGroup: null,
			rendered: false,
		};
	},
	provide() {
		return { getLayer: () => this.layer, };
	},
	computed: {
		layer() {
			return this.layerGroup;
		}
	},
	beforeDestroy() {
		this.removeLayerGroup();
		this.rendered = false;
	},
	methods: {
		createLayerGroup(markers = []) {
			if (this.layerGroup) this.removeLayerGroup();
			this.layerGroup = this.leaflet.featureGroup(markers);
			this.layerGroup.addTo(this.state.map);
			if (this.$listeners && this.$listeners.layeradd)
				this.layerGroup.on('layeradd', () => this.$emit('layeradd'));
			if (this.$listeners && this.$listeners.layerremove)
				this.layerGroup.on('layerremove', () => this.$emit('layerremove'));
		},
		removeLayerGroup() {
			if (!this.layerGroup) return;

			this.layerGroup.clearLayers();

			if (this.state.map && this.state.map.hasLayer(this.layerGroup)) {
				this.layerGroup.remove();
			}
			this.layerGroup = null;
		},
		getBounds() {
			return this.layerGroup ? this.layerGroup.getBounds() : null;
		},
		addLayers(markers) {
			this.createLayerGroup(markers);
		},
	},
	render(createElement) {
		if (this.state.map && !this.rendered) {
			if (this.layerGroup) this.removeLayerGroup();
			this.createLayerGroup();
			this.rendered = true;
		}
		return this.$scopedSlots.default ? createElement('div', this.$scopedSlots.default({})) : null;
	}
};
</script>
